export const JOB_MANAGER_PREVIEW_KEY = 'jobManager';
